import {
  getV1CompaniesCompanyIdLoadsTypeahead,
  Load_Read_Typeahead,
} from '@treadinc/horizon-api-spec';
import { FieldValues } from 'react-hook-form';

import AsyncAutocompleteField from '../v2/Autocomplete/AsyncAutocompleteField';
import { CommonAsyncAutocompleteFieldProps } from '../v2/Autocomplete/types';

type Props<T extends FieldValues> = CommonAsyncAutocompleteFieldProps<
  T,
  Load_Read_Typeahead,
  Load_Read_Typeahead,
  Record<string, unknown>
> & { companyId: string };

export default function AutocompleteLoadsTypeahead<T extends FieldValues>({
  companyId,
  isDisabled,
  ...rest
}: Props<T>) {
  return (
    <AsyncAutocompleteField
      {...rest}
      isDisabled={companyId ? isDisabled : true}
      queryName="AutocompleteLoadsTypeahead"
      fetchFn={{
        arguments: { path: { 'company-id': companyId } },
        request: getV1CompaniesCompanyIdLoadsTypeahead,
      }}
      parseFn={(item: Load_Read_Typeahead) => ({
        _entity: item,
        label: item.load_id,
        value: item.load_id,
      })}
    />
  );
}
